import accounting from "accounting";
const moneyFormat = function(string) {
  const option = {
    symbol: "฿",
    decimal: ".",
    thousand: ",",
    precision: 0,
    format: "%s%v"
  };
  return accounting.formatMoney(string, option);
};
export default moneyFormat;
